import { Typography } from '../../../designComponents';
import {
  InfoRowStyled,
  VerticalSpaceStyled,
} from '../../../style/reusableStyle';
import { ViewProposalContainerStyled } from './style';

type Props = {
  professionalNotes: string;
};
const ProfessionalNote = (_props: Props) => {
  return (
    <ViewProposalContainerStyled>
      <Typography
        variant="normal"
        className="title-header"
        fontColor="secondary"
        strong
      >
        TECHNICIAN NOTE{' '}
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled>
          <div style={{ display: 'block' }}>
            <Typography style={{ marginBottom: '10px' }}>Notes :</Typography>
            <Typography className="value">
              {_props.professionalNotes}
            </Typography>
          </div>
        </InfoRowStyled>
      </VerticalSpaceStyled>
    </ViewProposalContainerStyled>
  );
};

export default ProfessionalNote;
